import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { ApiService } from '../../services/api/api.service';
import { Data } from '../../models/data';
import { NavController } from '@ionic/angular';
import { Router, NavigationEnd } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Nav } from '../../models/nav';
import { NavService } from '../../services/nav/nav.service';
import * as moment from 'moment';

//import { UntypedFormGroup } from '@angular/forms';



export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
})
export class DashboardPage implements OnInit, OnDestroy {

  //idleState = "Not started.";
  panelOpenState = false;

  open(menu)
  {
    menu.openMenu();
  }
  
  data = new Data();

  user: any;
  //wallet: any;
  image: any;
  classes = [];
  cantopup: any;

  current_year: number = new Date().getFullYear();
  currentTime: string = moment().format('M/D/YYYY hh:mm:ss a');
  allowALL = true;
  allowSAF = true;
  allowPANJI = true;
  allowVM = true;

  allowMRC = true;
  allowKOPBB = true;

  transaction: any;
  yearlist: any;

  id: any;

  //profitloss  
  navigationSubscription;
  transaction2: any;
  totalAmountInClasses = 0;
  class_in : any;
  totalClassesIn= 0;
  tClassesAmountIn: any;

  totalAmountOutClasses = 0;
  class_out : any;
  totalClassesOut= 0;
  tClassesAmountOut: any;
  classesout:any;
  tAmountIn: any;
  tAmountOut: any;

  //
  detail = {product_name: null, price: null, date_added: null, value: null, order_id: null, model: null, value2: null, model2: null};
  myId: any;
  cat_name: any;
  class: any;
  year: any;
  company: any;
  total_amountIn: any;
  total_amountOut: any;


  //upload
  //photoForm!: UntypedFormGroup;


  constructor(private authService: AuthService,
              private apiService: ApiService,
              private navCtrl: NavController,
              private spinner: NgxSpinnerService,
              public dialog: MatDialog,
              private navService: NavService,
              private router: Router) {
    this.image = 'assets/img/user/nophoto.png';

    this.data =  {
      id: 2,
      name: 'getParamDashboard',
      content: localStorage.getItem('user')
    };

  }

  /*photoModal(largeDataModal: any) {
    this.modalService.open(largeDataModal, { size: 'md', centered: true });
  }

    savePhoto() {

    const data = {
      action: 'addReportImage',
      filename: this.image,
      type: this.img_type,
      report: this.id,
      user: localStorage.getItem('userid')
    }

    this.apiService.postData(data).subscribe((response) => {

      let currentUrl = this.router.url;

      console.log(response);

      this.image = [];
      this.img_type = [];

      this.modalService.dismissAll();
      this.photoForm.reset();

      this.router.navigateByUrl('/patient', { skipLocationChange: true }).then(() => {
        this.router.navigate([currentUrl]);
      });

    });

  }*/

  ngOnInit() 
  {
    this.refresh();
    var id = localStorage.getItem('user');
    console.log(id);

      //allow all accounts except Safinat, Panji & MRC for husna
      switch(id) 
      {
        case '2181': this.allowALL = false; break;//safinat@gmail.com
        case '2346': this.allowALL = false; break;//panji@gmail.com
        case '1997': this.allowALL = true; break;//husna@gmail.com
          case '2943': this.allowALL = false; break;//demo@account.com
          case '2947': this.allowALL = false; break;//campbell@account.com
          case '3014': this.allowALL = false; break;//mranti@account.com
          case '3015': this.allowALL = false; break;//nadipenanti@account.com

        case '2365': this.allowALL = false; break;//mrc@gmail.com
        case '2409': this.allowALL = false; break;//kopbb@gmail.com
        default: this.allowALL = true;
      }
      
      //allow account Safinat only for safinat
      switch(id) 
      {
        case '2181': this.allowSAF = true; break;//safinat@gmail.com
        case '2346': this.allowSAF = false; break;//panji@gmail.com/panji
        case '1997': this.allowSAF = false; break;//husna@gmail.com/husna1234
          
          case '2943': this.allowSAF = false; break;//demo@account.com
          case '2947': this.allowSAF = false; break;//campbell@account.com
          case '3014': this.allowSAF = false; break;//mranti@account.com
          case '3015': this.allowSAF = false; break;//nadipenanti@account.com

        case '2365': this.allowSAF = false; break;//mrc@gmail.com
        case '2409': this.allowSAF = false; break;//kopbb@gmail.com
        default: this.allowSAF = true;
      }

      //allow account without company section only for VM mranti/campbell/nadipenanti
      switch(id) {
        case '2181': this.allowVM = false; break;//safinat@gmail.com
        case '2346': this.allowVM = false; break;//panji@gmail.com
        case '1997': this.allowVM = false; break;//husna@gmail.com
        case '2365': this.allowVM = false; break;//mrc@gmail.com
        case '2409': this.allowVM = false; break;//kopbb@gmail.com
        
        case '2343': this.allowVM = true; break;//demo@account.com
        case '2347': this.allowVM = true; break;//campbell@account.com
        case '3014': this.allowVM = true; break;//mranti@account.com
        case '3015': this.allowVM = true; break;//nadipentanti@account.com

        default: this.allowVM = true;
      }


      //allow account Panji only for panji
      switch(id) {
        case '2181': this.allowPANJI = false; break;//safinat@gmail.com
        case '2346': this.allowPANJI = true; break;//panji@gmail.com
        case '1997': this.allowPANJI = false; break;//husna@gmail.com
          case '2943': this.allowPANJI = false; break;//demo@account.com
          case '2947': this.allowPANJI = false; break;//campbell@account.com
          case '3014': this.allowPANJI = false; break;//mranti@account.com
          case '3015': this.allowPANJI = false; break;//nadipenanti@account.com
        case '2365': this.allowPANJI = false; break;//mrc@gmail.com
        case '2409': this.allowPANJI = false; break;//kopbb@gmail.com

        default: this.allowPANJI = true;
      }

        //allow account MRC only for mrc
        switch(id) {
          case '2181': this.allowMRC = false; break;//safinat@gmail.com
          case '2346': this.allowMRC = false; break;//panji@gmail.com
          case '2365': this.allowMRC = true; break;//mrc@gmail.com
          case '1997': this.allowMRC = false; break;//husna@gmail.com
            case '2943': this.allowMRC = false; break;//demo@account.com
            case '2947': this.allowMRC = false; break;//campbell@account.com
            case '3014': this.allowMRC = false; break;//mranti@account.com
            case '3015': this.allowMRC = false; break;//nadipenanti@account.com
          case '2409': this.allowMRC = false; break;//kopbb@gmail.com

          default: this.allowMRC = true;
        }

          //allow account KOPBB only for kopbb
          switch(id) {
            case '2181': this.allowKOPBB = false; break;//safinat@gmail.com
            case '2346': this.allowKOPBB = false; break;//panji@gmail.com
            case '2365': this.allowKOPBB = false; break;//mrc@gmail.com
            case '1997': this.allowKOPBB = false; break;//husna@gmail.com

              case '2943': this.allowKOPBB = false; break;//demo@account.com
              case '2947': this.allowKOPBB = false; break;//campbell@account.com
              case '3014': this.allowKOPBB = false; break;//mranti@account.com
              case '3015': this.allowKOPBB = false; break;//nadipenanti@account.com

            case '2409': this.allowKOPBB = true; break;//kopbb@gmail.com

            default: this.allowKOPBB = true;
          }
  

          //get year of company
          /*this.data =  {
            id: 7,
            name: 'getYearCompany',
            content: {
              id : localStorage.getItem('user')
            }
          };
      
          console.log(this.data);
          this.apiService.postData(this.data).subscribe((response) => {
            console.log(response);
            this.transaction = response.data;
            this.yearlist = this.transaction;
          });*/
          //end year

    this.apiService.postData(this.data).subscribe((response) => {
      console.log(response);
      this.detail = response.data[1];

        this.data = {
          id: 3,
          name: 'getProfitLossPanji2010',
          content: localStorage.getItem('user')
        };

        console.log(this.data+this.myId+'fairuz');

        this.apiService.postData(this.data).subscribe((response) => {

          console.log(response);

          this.cat_name = response.data.cat_name;
          this.class = response.data.class;
          this.year = response.data.item_discount;
          this.company = response.data.company;
          this.total_amountIn = response.data.total_amountIn;
          this.total_amountOut = response.data.total_amountOut;

        });

    });
    
  }

  refresh() {

    this.spinner.show();
    this.apiService.postData(this.data).subscribe((response) => {
      this.user = response.data.user;

      console.log(response);
      localStorage.setItem('firstname', this.user.userid);
      localStorage.setItem('firstname', this.user.firstname);
      localStorage.setItem('lastname', this.user.lastname);
      localStorage.setItem('companyg', this.user.companyg);
      localStorage.setItem('address', this.user.addr);
      localStorage.setItem('phone', this.user.telephone);
      localStorage.setItem('email', this.user.email);

      this.spinner.hide();

      if( response.data.user.acc_type == 1 && response.data.user.level_class_id==3) this.cantopup = 1;
      else this.cantopup = 0;
      localStorage.setItem('cantopup', this.cantopup);
      localStorage.setItem('tml', response.data.user.acc_type);
      localStorage.setItem('level', response.data.user.level_class_id);

      console.log(response.data.user.acc_type);
      console.log(response.data.user.level_class_id);
      console.log('cantopup' + this.cantopup);
      
    });

  }


  getFirstName() {
    //console.log(this.user);
    if (this.user) {
      return this.user.firstname;
    } else {
      return null;
    }
  }

  getLastName() {
    //console.log(this.user);
    if (this.user) {
      return this.user.lastname;
    } else {
      return null;
    }
  }

  getUserId() {
    //console.log(this.user);
    if (this.user) {
      return this.user.customer_id;
    } else {
      return null;
    }
  }

  /*getYearId(int) {
    if (this.classes.length > 0 ) {
      return this.classes[int].date;
    } else {
      return null;
    }
  }

  getCompId(int) {
    //console.log(this.user);
    if (this.user) {
      return this.user.companyg;
    } else {
      return null;
    }
  }*/

  getCompany() {
    //console.log(this.user);
    if (this.user) {
      return this.user.companyg;
    } else {
      return null;
    }
  }


  setLogout() {
    this.authService.logout();
  }

  ngOnDestroy() {

     if (this.navigationSubscription) {
        this.navigationSubscription.unsubscribe();
     }
   }

   openDialog(): void {
    const dialogRef = this.dialog.open(DialogPage, {
      width: '280px',
      data: {name: 'name', animal: 'hello'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  logout() {
    this.authService.logout();
  }

  //upload
  onNavigate()
  {
    var id = localStorage.getItem('user');
    console.log(this.id);
    window.open("https://accounting.dexasia.com.my/upload_purchase2.html?customer_id=" + localStorage.getItem('user'), "_blank");
  }

  onNavigateInvoice(){
      window.open("https://accounting.dexasia.com.my/upload_invoice.html?customer_id=" + localStorage.getItem('user'), "_blank");
  }

  onNavigateBank(){
      window.open("https://accounting.dexasia.com.my/upload_bank.html?customer_id=" + localStorage.getItem('user'), "_blank");
  }

  profitLossPanji2010()
  {
    var id = localStorage.getItem('user');
    console.log(this.id);
    window.open("https://task.dexasia.com.my/form/profitloss.php?yr=2010&comp=0", "_blank");
  }

   
 
}

@Component({
  selector: 'mydialog',
  templateUrl: 'dialog.html',
})
export class DialogPage {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

}

  
